import { combineReducers } from "redux";

import { application } from "./application";
import { configuration } from "./configuration";
import { documentCapture } from "./documentCapture";
import { faceCapture } from "./faceCapture";
import { faceLiveness3D } from "./faceLiveness3D";
import { livenessTest } from "./livenessTest";
import { navigation } from "./navigation";
import { resendVerificationCode } from "./resendVerificatioCode";
import {apiFetch} from "./apiFetch"

export const rootReducer = combineReducers({
  application,
  configuration,
  documentCapture,
  faceCapture,
  faceLiveness3D,
  livenessTest,
  navigation,
  resendVerificationCode,
  apiFetch
});
